// extracted by mini-css-extract-plugin
module.exports = {"container":"gift-card-layout_container__nKq3L","content":"gift-card-layout_content__pgpx0"};